const importAll = (requireContext) => {
  return requireContext.keys().map(requireContext);
};

const images2016 = importAll(
  require.context("../assets/2016", false, /\.(png|jpe?g|svg)$/)
);

export default images2016;
